import BaseAPI from './base.api.service'

const resource = 'carrentals';
export default {
    async getCarRental(erID) {
        return await BaseAPI.get(`expensereports/${erID}/CarRental`);
    },
    async getRentalCarCompanyTypes() {
        return await BaseAPI.get(`${resource}/RentalCompanies`);
    },
    async getMoreThanCompactClassTypes() {
        return await BaseAPI.get(`${resource}/MoreThanCompactClassTypes`)
    },
    async getAmountClaimedLessThanPaidReasons() {
        return await BaseAPI.get(`${resource}/AmountClaimedLessThanPaidReasons`)
    }
} 